import { initializeApp } from 'firebase/app';
import { getAuth, User } from 'firebase/auth';

//IMPORTANT: These client-side vars must be added to next.config.mjs.
export const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID
};

const app = initializeApp(firebaseConfig);

export const auth =
  process.env.NEXT_PUBLIC_E2E_AUTH === '1'
    ? ({ currentUser: null } as unknown as ReturnType<typeof getAuth>)
    : getAuth(app);

/**
 * Returns true when running under Playwright E2E tests with Firebase auth mocking active.
 * Activated by either NEXT_PUBLIC_E2E_AUTH=1 (new, auth-only) or NEXT_PUBLIC_E2E=1 (legacy).
 */
export function isE2EAuthMode(): boolean {
  return (
    process.env.NEXT_PUBLIC_E2E_AUTH === '1' ||
    process.env.NEXT_PUBLIC_E2E === '1'
  );
}

/**
 * Fake E2E Firebase user — returned immediately by onAuthStateChanged
 * when auth mock is active so the booking page never shows the OTP modal.
 */
export const E2E_FAKE_USER = {
  uid: 'e2e-fake-uid',
  email: 'jmullenix+test@mauiresortrentals.com',
  emailVerified: true,
  displayName: 'E2E Test User',
  getIdToken: async () => 'e2e-fake-firebase-id-token',
} as unknown as User;

export default app;
